<script setup>
import ErrorLayout from "@/Layouts/ErrorLayout.vue";
import {computed} from "vue";
import {usePage} from "@inertiajs/inertia-vue3";

const props = defineProps({});

const app = computed(() => {
    return usePage().props.value.app;
})

</script>

<template>
    <ErrorLayout code="404" heading="Not Found">
        <p>
            The resource you're looking for cannot be found.
        </p>
        <p>
            If you believe the resouce SHOULD exist at this URL and the problem persists, please contact us by sending
            an email to <a href="mailto:support@motorpress.co.za">support@motorpress.co.za</a>
        </p>
    </ErrorLayout>
</template>

<style scoped>

</style>
